import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import ServicesLanding from "../views/ServicesLanding";
import SolarPower from "../ones/SolarPower";
import SolarWaterPumping from "../ones/SolarWaterPumping";
import SolarHeating from "../ones/SolarHeating";
import Electrical from "../ones/Electrical";
import StreetLights from "../ones/StreetLights";
import Maintenance from "../ones/Maintenance";
import Track from "../ones/Track";
import Drilling from "../ones/Drilling";

export default function Services() {
  const appContext = useContext(AppContext);
  const [view, setView] = useState(null);

  function getView() {
		if(
			!appContext.navSubItem &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <ServicesLanding/>
		} else if (appContext.navSubItem === 'solar_power_solutions'){
      return <SolarPower />
    } else if (appContext.navSubItem === 'solar_water_pumping'){
      return <SolarWaterPumping />
    } else if (appContext.navSubItem === 'solar_heating_refrigeration'){
      return <SolarHeating />
    } else if (appContext.navSubItem === 'electrical_security_installations'){
      return <Electrical />
    } else if (appContext.navSubItem === 'streetlights_wind_energy'){
      return <StreetLights/> 
    } else if (appContext.navSubItem === 'maintenance_backup_services'){
      return <Maintenance/> 
    } else if (appContext.navSubItem === 'projects_track_record'){
      return <Track/> 
    } else if (appContext.navSubItem === 'drilling'){
      return <Drilling/> 
    }

		return null;
	}

  useEffect(() => {
    setView(getView());
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem]);

  return view;
}
